import { ChangeDetectionStrategy, Component, computed, contentChild, inject, input, output } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { IEvRouteLink } from "src/services/shared/link-helper.service";
import { NgTemplateOutlet } from "@angular/common";

const ONCLICK_DEFAULT = () => {};

@Component({
    selector: "list-item",
    templateUrl: "./list-item.component.html",
    styleUrl: "./list-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, NgTemplateOutlet],
})
export class ListItemComponent {
    router = inject(Router);
    itemText = input<string>(null);
    itemType = input<"list-default" | "external-link" | "divider">("list-default");
    routeLink = input<IEvRouteLink>(null);

    paddingLeft = input<number>(30);
    paddingRight = input<number>(30);
    theme = input<"blue">("blue");

    onClick = output();

    styleClasses = computed(() => {
        return this.itemType() + " " + this.theme();
    });

    _onClick() {
        this.onClick.emit();
    }
    _onRouteClick(link: IEvRouteLink) {
        //this.router.navigate([link.routerLink], { queryParams: link.routerLinkParams });
    }
}
